<template>
  <a-modal v-model="visible" width="1000px" title="选择测试用例" :ok-button-props="{ props: { loading: okLoading } }" @ok="onSubmit" @cancel="onCancel">
    <a-transfer ref="transfer" class="tree-transfer" :list-style="listStyle" :data-source="transferDataSource" show-search :show-select-all="true" :target-keys="targetKeys" :render="item => item.title" @change="handleChange" @search="handleSearch">
      <template slot="children" slot-scope="{ props: { direction, selectedKeys }, on: { itemSelect } }">
        <a-tree
          v-if="direction === 'left'"
          block-node
          :tree-data="treeData"
          show-line
          :expanded-keys.sync="expandedKeys"
          checkable
          :checked-keys="[...selectedKeys, ...targetKeys]"
          @check="
            (keys, props) => {
              onChecked(keys, props, [...selectedKeys, ...targetKeys], itemSelect);
            }
          "
          @select="
            (keys, props) => {
              onChecked(keys, props, [...selectedKeys, ...targetKeys], itemSelect);
            }
          "
        >
          <template slot="title" slot-scope="item">
            <span class="node-title">
              {{ item.title }}<span v-if="item.count > 0" class="node-title_total">({{ item.count }})</span>
            </span>
          </template>
        </a-tree>
      </template>
    </a-transfer>
  </a-modal>
</template>

<script>
import { moduleList } from '@/api/project/case';

function isChecked(selectedKeys, eventKey) {
  return selectedKeys.indexOf(eventKey) !== -1;
}

export default {
  name: 'CaseSelector',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    planBindKeys: {
      type: Array,
      default() {
        return [];
      }
    },
    okLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      listStyle: {
        width: '400px',
        height: '400px',
        overflow: 'auto'
      },
      targetKeys: [],
      transferDataSource: [],
      treeData: [],
      treeDataCopy: [],
      expandedKeys: [],
      treeList: [],
      projectId: parseInt(this.$route.params.project_id) || null
      // okLoading: false
    };
  },
  watch: {
    isShow() {
      this.visible = this.isShow;
      if (this.isShow) {
        this.getCaseList();
      }
    },
    planBindKeys: {
      immediate: true,
      handler(val) {
        this.targetKeys = val;
      }
    },
    data: {
      immediate: true,
      handler(val) {
        if (val && val.length > 0) {
          const temp = [];
          this.treeToList(val, temp);
          this.transferDataSource = temp;
          this.treeData = val;
          this.treeDataCopy = JSON.parse(JSON.stringify(val));
          this.expandedKeys = this.treeData.filter(item => !item.key.startsWith('module-0')).map(module => module.key);
        }
      }
    }
  },
  methods: {
    getCaseList() {
      moduleList({ project_id: this.projectId, detailed: true }).then(res => {
        this.moduleCases = res.data.module_cases;
        const items = res.data.items.map(item => {
          return {
            id: item.id,
            title: item.title,
            key: 'module-' + item.key,
            children: [],
            parent_id: item.parent_id
          };
        });
        const caseData = [
          {
            id: 0,
            key: 'module-0',
            title: '未分配',
            children: this.moduleCases['null'],
            count: this.moduleCases['null'] ? this.moduleCases['null'].length : 0,
            scopedSlots: { title: 'title' }
          },
          ...this.listToTree(items)
        ];
        this.treeList = JSON.parse(JSON.stringify(caseData));
        const temp = [];
        this.treeToList(caseData, temp);
        this.transferDataSource = temp;
        this.treeData = caseData;
        this.treeDataCopy = JSON.parse(JSON.stringify(caseData));
        this.expandedKeys = this.treeData.filter(item => !item.key.startsWith('module-0')).map(module => module.key);
      });
    },
    listToTree(list, parentId = 0) {
      const menuObj = {};
      const tempArr = [];
      list.forEach(item => {
        const temp = {
          ...item,
          children: this.moduleCases[item.id.toString()] || [],
          count: this.moduleCases[item.id.toString()] ? this.moduleCases[item.id.toString()].length : 0,
          scopedSlots: { title: 'title' }
        };
        tempArr.push(temp);
        menuObj[item.id] = temp;
      });
      return tempArr.filter(item => {
        if (item.parent_id !== parentId) {
          const father = menuObj[item.parent_id];
          if (!father) {
            return false;
          }
          father.children.push(item);
          return false;
        }
        return true;
      });
    },
    treeToList(treeDataArr, ret = []) {
      if (treeDataArr) {
        treeDataArr.forEach(item => {
          if (item.children) {
            this.treeToList(item.children, ret);
            const total = item.children.reduce((sum, c) => sum + c.count || 0, 0);
            item.count += total;
          } else {
            ret.push(item);
          }
        });
      }
    },
    onSelect(selectKeys) {
      this.$emit('select', selectKeys);
    },
    onChecked(keys, e, checkedKeys, itemSelect) {
      const { eventKey } = e.node;
      itemSelect(eventKey, !isChecked(checkedKeys, eventKey));
      if (eventKey.startsWith('module-')) {
        const treeData = JSON.parse(JSON.stringify(this.treeList));
        const node = this.findTreeNode(eventKey, treeData);
        const childKeys = this.findChildren(node);
        childKeys.forEach(key => {
          itemSelect(key, !e.node.checked);
        });
      }
    },
    findChildren(node) {
      let childKeys = [];
      if (node && node.children) {
        node.children.forEach(child => {
          childKeys.push(child.key);
          const keys = this.findChildren(child);
          childKeys = childKeys.concat(keys);
        });
      }
      return childKeys;
    },
    findTreeNode(targetKey, treeData) {
      const arr = Array.isArray(treeData) ? treeData : [treeData];
      let result = null;
      while (arr.length) {
        const item = arr.pop();
        if (item && item.key === targetKey) {
          result = item;
          break;
        } else if (item && item.children && item.children.length) {
          arr.push(...item.children);
        }
      }
      return result;
    },
    searchTreeNode(value, treeData) {
      for (let i = treeData.length - 1; i >= 0; i--) {
        const item = treeData[i];
        if (!item.key.startsWith('module-') && !item.title.includes(value)) {
          treeData.splice(i, 1);
        } else if (item.children) {
          this.searchTreeNode(value, item.children);
        }
      }
    },
    close() {
      this.targetKeys = [];
      this.$emit('close');
    },

    onCancel() {
      this.utils.trackClick({ name: '取消关联用例' });
      this.close();
    },

    filterOption(inputValue, option) {
      return option.title.indexOf(inputValue) > -1;
    },

    handleChange(targetKeys) {
      this.targetKeys = targetKeys.filter(key => !key.startsWith('module-'));
    },

    handleSearch(dir, value) {
      if (dir === 'left') {
        if (value) {
          this.searchTreeNode(value, this.treeData);
        } else {
          this.treeData = JSON.parse(JSON.stringify(this.treeDataCopy));
        }
      }
    },

    onSubmit() {
      this.utils.trackClick({ name: '提交关联用例' });
      this.$emit('close', this.targetKeys);
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .tree-transfer .ant-transfer-list:first-child {
  width: 50%;
  flex: none;
}
</style>
